import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import { Reset } from 'styled-reset'
import { Helmet } from 'react-helmet'
import styled, { createGlobalStyle, ThemeProvider } from 'styled-components'
import theme from '~/theme'
import ContextProvider from '~/provider/ContextProvider'
import Header from '~/components/Header'
import Footer from '~/components/Footer'
import { AttentionBanner } from '~/components/AttentionBanner'
import { mediaqueries } from '~/utils/mediaqueries'

const GlobalStyles = createGlobalStyle`
  html {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    color: ${({ theme }) => theme.color('dark')};
    font-size: 16px;
  }
  
  *, *:before, *:after {
    -webkit-box-sizing: border-box !important;
    -moz-box-sizing: border-box !important;
    -ms-box-sizing: border-box !important;
    box-sizing: border-box !important;  
  }
    
  body {
    background: ${({ theme }) => theme.color('light')};
    box-sizing:border-box !important;
  }

  .reactour__helper {
    padding: 0 !important;
    background-color: transparent !important;

    & > span {
      display: none;
    }

    & > div {
      margin: 0 !important;
    }
  }

  #tidio-chat-iframe {
    right: auto !important;
    left: 0 !important;
    bottom: 85px !important;

    @media ${mediaqueries.md} {
      bottom: 0 !important;
    }
  }

  @keyframes marquee {
    0% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }
    to {
      -webkit-transform: translateX(-100%);
      transform: translateX(-100%);
    }
  }
  
  #wheelAccept {
    color: #1F2228;
  }

  input#field2 {
    border: 1px solid rgb(225, 228, 237);
}
`

const Wrapper = styled.div`
  display: flex;
  flex: 1 0 auto;
`

const Main = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-bottom: 70px;

  @media ${mediaqueries.md} {
    padding-bottom: 0;
  }
`

const Layout = ({ children, location }) => {
  return (
    <ContextProvider location={location}>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        ></meta>
        <meta name="apple-mobile-web-app-capable" content="yes"></meta>
        <script
          type="text/javascript"
          src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
          async
        ></script>
      </Helmet>
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <ThemeProvider theme={theme}>
            <Main>
              <GlobalStyles />
              <Reset />
              <AttentionBanner>
                <span>🔥 10% RABAT - brug koden WELCOME10 ved kassen</span>
                <span>&nbsp;|&nbsp;</span>
                <span>🎁 Køb to og få 50% på den ene</span>
                {location.pathname !== '/' && (
                  <>
                    <span>&nbsp;|&nbsp;</span>
                    <span>🚚 Gratis fragt til hele verden</span>
                  </>
                )}
              </AttentionBanner>
              <Header
                location={location}
                siteTitle={data.site.siteMetadata.title}
              />
              <Wrapper>{children}</Wrapper>
              <Footer />
            </Main>
          </ThemeProvider>
        )}
      />
    </ContextProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
